import React, { memo } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ButtonBase from '@mui/material/ButtonBase';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const AddButton: React.FC<Props> = memo(function AddButton({ onClick, disabled }) {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={{
        position: 'absolute',
        borderRadius: 100,
        bottom: 20,
        right: 25,
        width: '50px',
        height: '50px',
        backgroundColor: disabled ? 'rgba(0, 0, 0, 0.26)' : '#1976D2',
      }}>
      <AddIcon sx={{ color: 'white' }} />
    </ButtonBase>
  );
});
